export default "/images/logo-21.png?09a7c715dc6e0a6110de5757fd752932";